import { render, staticRenderFns } from "./PaymentRequestModal.vue?vue&type=template&id=74e4d97e"
import script from "./PaymentRequestModal.vue?vue&type=script&lang=js"
export * from "./PaymentRequestModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentRequestModal.vue?vue&type=style&index=0&id=74e4d97e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports